/* unplugin-vue-components disabled */import script from "./RoleCardAchievementTalent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCardAchievementTalent.vue?vue&type=script&setup=true&lang=js"

import "./RoleCardAchievementTalent.vue?vue&type=style&index=0&id=c59d6692&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c59d6692"]])

export default __exports__